import { TOOLTIP_PORTAL_ROOT_ID } from './tooltipConfig';

export function TooltipPortalRoot() {
  return <div id={TOOLTIP_PORTAL_ROOT_ID} />;
}
